import React, { useMemo } from "react";
import { Box, Typography, Paper, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

const TopBarContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1.5),
  backgroundColor: '#f9faff',
  color: '#333333',
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[2],
  margin: '10px'
}));

const InfoItem = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.5),
}));


const EmpTopBar = ({ formData, workflowDetails: workflowDetailsProp }) => {
  const tenantId = formData?.tenantId || window?.Digit?.ULBService?.getCurrentTenantId();
  const { data: hookWorkflowDetails, isLoading } = window?.Digit?.Hooks?.useWorkflowDetails({
    tenantId: tenantId,
    id: formData?.applicationNo,
    moduleCode: formData?.businessService || "BPA",
    config: {
      enabled: !workflowDetailsProp && !!formData?.applicationNo && !!tenantId,
    },
  });

  const workflowDetails = workflowDetailsProp || hookWorkflowDetails;

  const totalSubmissions = useMemo(() => {
    const timeline = workflowDetails?.timeline || workflowDetails?.data?.timeline;
    if (!timeline || timeline.length === 0) return 1;

    const getItemEpoch = (item) =>
      item?.auditDetails?.lastModifieds || item?.auditDetails?.lastModifiedTime || 0;

    // Sort chronologically (oldest first)
    const sorted = [...timeline].sort((a, b) => getItemEpoch(a) - getItemEpoch(b));

    // A break action indicates the file was sent back / rejected / approved.
    // A NEW submission is only counted when there are more meaningful actions AFTER the break.
    const breakActions = ["SHORTFALL", "REJECTED", "REJECT", "APPROVED", "SEND_BACK"];
    // Actions that don't count as "meaningful next steps" after a break
    const trivialActions = ["UPLOAD_DOC"];

    let count = 1;
    for (let i = 0; i < sorted.length; i++) {
      const action = sorted[i]?.action || "";
      if (!breakActions.includes(action)) continue;
      // Check if there is at least one non-trivial action after this break
      const hasNextStep = sorted.slice(i + 1).some(
        (item) => !trivialActions.includes(item?.action || "")
      );
      if (hasNextStep) count++;
    }

    return count;
  }, [workflowDetails]);

  const oldApplicationNo = formData?.prevFileNo || formData?.obpasFileNumber || "N/A";

  return (
    <TopBarContainer>
      <Grid container spacing={2}>
        {/* First Row */}
        <Grid item xs={12} md={4}>
          <InfoItem>
            <Typography variant="subtitle2" fontWeight="bold">
              FASTPAS ID:
            </Typography>
            <Typography variant="body2" fontStyle="italic" fontWeight="bold">
              {formData?.land_Id || "NA"}
            </Typography>
          </InfoItem>
        </Grid>

        <Grid item xs={12} md={4}>
          <InfoItem>
            <Typography variant="subtitle2" fontWeight="bold">
              Application No:
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {formData?.applicationNo || "NA"}
            </Typography>
          </InfoItem>
        </Grid>

        <Grid item xs={12} md={4}>
          <InfoItem>
            <Typography variant="subtitle2" fontWeight="bold">
              Total No. of Submissions:
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {isLoading && !workflowDetails ? "Loading" : totalSubmissions}
            </Typography>
          </InfoItem>
        </Grid>
        {/* <Grid item xs={12} md={4}>
          <InfoItem>
            <Typography variant="subtitle2" fontWeight="bold">
              {formData?.riskType || "NA"}
            </Typography>
          </InfoItem>
        </Grid> */}

        {/* Second Row */}
        <Grid item xs={12} md={4}>
          <InfoItem>
            <Typography variant="subtitle2" fontWeight="bold">
              {formData?.professionaldetails?.consultantCategory || formData?.professionalInformation?.consultantCategory || "NA"}:
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {formData?.professionaldetails?.name || formData?.professionalInformation?.name || "NA"}
            </Typography>
          </InfoItem>
        </Grid>

        <Grid item xs={12} md={4}>
          <InfoItem>
            <Typography variant="subtitle2" fontWeight="bold">
              LTP Mobile No:
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {formData?.professionaldetails?.mobileNumber || formData?.professionalInformation?.mobileNumber || "NA"}
            </Typography>
          </InfoItem>
        </Grid>

        <Grid item xs={12} md={4}>
          <InfoItem>
            <Typography variant="subtitle2" fontWeight="bold">
              Owner Name:
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {formData?.landInfo?.owners?.[0]?.name || "NA"}
            </Typography>
          </InfoItem>
        </Grid>

        {/* Third Row */}
        <Grid item xs={12} md={4}>
          <InfoItem>
            <Typography variant="subtitle2" fontWeight="bold">
              Old Application Number:
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {oldApplicationNo}
            </Typography>
          </InfoItem>
        </Grid>
      </Grid>
    </TopBarContainer>
  );
};

export default EmpTopBar;